import Header from "../../components/Header.vue";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import axios from "axios";
import Vue from "vue";

export default {
    components: {
        Header,
        VuetablePagination
    },
    name: 'DetailsSuivieEnlevement',
    data: function() {
        const query = this.$route.query;
        return {
            id_navire: this.$route.params.id_navire,
            num_bl: decodeURIComponent(this.$route.params.num_bl),
            element: [],
            dateOptions: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
            },
            criteriacolOptions: [
                { value: '', label: 'Toute' },
                { value: 'voyage', label: 'Voyage' },
                { value: 'bl', label: 'BL' },
                { value: 'num_bl', label: 'Bill of Lading' },
                { value: 'marque', label: 'Marque' },
                { value: 'be', label: 'BE' },
                { value: 'num_ivoice', label: 'N° Declaration' },
                { value: 'transporteur', label: 'Transporteur' },
                { value: 'nom_chauffeur', label: 'Nom Chauffeur' },
                { value: 'permis', label: 'Permis' },
                { value: 'num_camion', label: 'N° Camion' },
                { value: 'num_remorque', label: 'N° Remorque' },
                { value: 'destination', label: 'Destination' },
            ],
            filtre: {
                current_page: parseInt(this.$route.query.page) > 0 ? parseInt(this.$route.query.page) : 1,
                per_page: 25,
                last_page: 1,
                recherche: query.filter || "",
                criteriacol: query.criteriacol || "",
            },
            paginationCss: {
                infoClass: 'pull-left ',
                wrapperClass: 'vuetable-pagination text-center',
                activeClass: 'btn-secondary',
                disabledClass: 'disabled',
                pageClass: 'btn btn-border',
                linkClass: 'btn btn-border',
                icons: {
                    first: '',
                    prev: '',
                    next: '',
                    last: '',
                },
            },
        }
    },
    methods: {
        gotoBack(){
            this.$router.go(-1);
        },
        showDatePicker(event) {
            if (event.target.showPicker) {
                event.target.showPicker();
            }
        },
        saveElement(element){
            let formulaire = new FormData();
            formulaire.append('date_paiement', element.date_paiement);
            formulaire.append('degat', element.degat);
            formulaire.append('montant_payer', element.montant_payer);
            formulaire.append('id', element.id);
            axios.post(this.BASE_URL+'/suivieenlevementdetail/save', formulaire)
                .then(response => {
                    if (response.data.error === "") {
                        console.log("Enregistrement effectué avec succès!");
                        Vue.$toast.open({
                            message: 'Enregistrement effectué avec succès!',
                            type: 'success',
                            position: 'top-right'
                            // all of other options may go here
                        });
                        this.fetchElement();
                    } else {
                        console.log("Erreur");
                        Vue.$toast.open({
                            message: response.data.error,
                            type: 'error',
                            position: 'top-right'
                        });
                    }
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });

        },
        fetchElement(){
            let formulaire = new FormData();
            formulaire.append("id_navire", this.id_navire);
            formulaire.append("num_bl", this.num_bl);
            formulaire.append("page", this.filtre.current_page);
            formulaire.append("per_page", this.filtre.per_page);
            formulaire.append("filter", this.filtre.recherche);
            formulaire.append("criteriacol", this.filtre.criteriacol);
            axios.post(this.BASE_URL+'/suivieenlevementdetail/getdetailsbynavireandnumblpaginated', formulaire)
                .then(response => {
                    this.element = response.data.element;
                    this.filtre.current_page = parseInt(response.data.current_page);
                    this.filtre.last_page = parseInt(response.data.last_page);
                    this.filtre.per_page = parseInt(response.data.per_page) || this.filtre.per_page;

                    this.$nextTick(() => {
                        if (this.$refs.pagination) {
                            this.$refs.pagination.setPaginationData({
                                current_page: this.filtre.current_page,
                                last_page: this.filtre.last_page,
                                per_page: this.filtre.per_page,
                                total: parseInt(response.data.total_rows),
                            });
                        }
                    });

                    this.syncPageToUrl();
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
        },

        onChangePage(page) {
            let target = page;
            if (page === 'next') target = this.filtre.current_page + 1;
            else if (page === 'prev') target = this.filtre.current_page - 1;
            target = Math.min(Math.max(target, 1), this.filtre.last_page || 1);

            if (target === this.filtre.current_page) return;
            this.filtre.current_page = target;
            this.fetchElement();
        },

        syncPageToUrl() {
            const query = {};
            if (this.filtre.recherche !== "") query.filter = this.filtre.recherche;
            if (this.filtre.criteriacol !== "") query.criteriacol = this.filtre.criteriacol;
            if (parseInt(this.filtre.current_page) > 1) query.page = String(this.filtre.current_page);

            if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
                this.$router.replace({ query }).catch(() => {});
            }
        },
        setFilter() {
            this.filtre.current_page = 1;
            this.fetchElement();
        },
        resetFilter() {
            this.filtre.recherche = "";
            this.filtre.criteriacol = "";
            this.setFilter();
        }
    },

    created: function() {


    },
    mounted: function() {
        this.fetchElement();

    }
}
